import React from "react";
import UserProfileView from '../../../../components/User/UserProfileView';
import UserPageLayout from '../../../../components/User/UserPageLayout';

const UserSecurity = () => (
    <UserPageLayout title="Security">
        <UserProfileView section="security" />
    </UserPageLayout>
);

export default UserSecurity;
